module.exports = __webpack_public_path__ + "img/KSC07085.eb23ddb6.jpg";